/// <reference path="Configuracion.js" />
/// <reference path="controlador.js" />
/// <reference path="ListaEmpresas.js" />

var oListaEmpresas;
var idflag = 1;
var visitaWeb = "";
var verPlanoInter = "";
var verMas = "";

function GetObjListaEmpresas() {
    if (oListaEmpresas == undefined) {
        oListaEmpresas = new ObjListaEmpresas();
    }
    return oListaEmpresas;
}

function ObjListaEmpresas() {
    var that = this;

    //this.urlSVR = "";

    //this.getUrlSVR = function (data) {
    //    that.urlSVR = data;
    //    GetCargaArchivos().cargarFicheroConfig(that.getUrlSVR, "../wsListaExpositores.svc/GetUrlSVR?");
    //}
    

    this.eventosInterfazGrafica = function () {
        $(".impresionLista").click(function (event) {
            event.preventDefault();
            GetObjControlador().imprimir(GetObjConstantes()._LISTA);
        });

        $(".impresionFavoritos").click(function (event) {
            event.preventDefault();
            GetObjControlador().imprimir(GetObjConstantes()._FAVORITOS);
        });

        $("#busquedaNormal").keypress(function (e) {
            //e.preventDefault();
            if (e.which == 13) {
                var textBuscar = encodeURIComponent($('#busquedaNormal').val());
                that.buscarTexto(textBuscar);
                return false;    //<---- Add this line
            }
        });

        $("#busquedaNormal").blur(function () {
            var textBuscar = encodeURIComponent($('#busquedaNormal').val());
            that.buscarTexto(textBuscar);
        });

        $("#btnBuscar").click(function () {
            var textBuscar = encodeURIComponent($('#busquedaNormal').val());
            that.buscarTexto(textBuscar);
        });

        $("#txtBuscarMovil").keypress(function (e) {
            if (e.which == 13) {
                var textBuscar = encodeURIComponent($('#txtBuscarMovil').val());
                that.buscarTexto(textBuscar);
                return false;    //<---- Add this line
            }
        });
        
        $("#txtBuscarMovil").blur(function () {
            var textBuscar = encodeURIComponent($('#txtBuscarMovil').val());
            that.buscarTexto(textBuscar);
        });

        $("#btnBuscarmovil").click(function () {
            var textBuscar = encodeURIComponent($('#txtBuscarMovil').val());
            that.buscarTexto(textBuscar);
        });

        $("#BusquedaLetra a").click(function (e) {
            e.preventDefault();
            var letraBusqueda = $(this).attr('id');
            $("#busquedaNormal").val("");
            GetObjListaEmpresas().limpiarFiltroPais();
            
            if ((letraBusqueda == "letraTodos")) {
                if (GetObjConfiguracion().busquedaActiva == "T") {
                    GetObjControlador().navegarAPagina(GetObjConstantes()._LISTA, '#LEMPRESAS&p=1&t=TODO'); 
                }
                else
                {
                    if ((GetObjConfiguracion().filtroBusquedaActiva == "")) {
                        if (GetObjConfiguracion().busquedaActiva == "S")
                            GetObjControlador().navegarAPagina(GetObjConstantes()._SECTOR, '#LSECTOR&p=1&t=TODO'); //window.location.hash = '#LSECTOR&p=1&t=TODO';
                        if (GetObjConfiguracion().busquedaActiva == "P")
                            GetObjControlador().navegarAPagina(GetObjConstantes()._PAIS, '#LPAISES&p=1&t=TODO'); //window.location.hash = '#LPAISES&p=1&t=TODO';
                        if (GetObjConfiguracion().busquedaActiva == "A")
                            GetObjControlador().navegarAPagina(GetObjConstantes()._ACTIVIDAD, '#LACTIVIDAD&p=1&t=TODO'); //window.location.hash = '#LACTIVIDAD&p=1&t=TODO';
                        if (GetObjConfiguracion().busquedaActiva == "O")
                            GetObjControlador().navegarAPagina(GetObjConstantes()._PRODUCTO, '#LPRODUCTOS&p=1&t=TODO'); //window.location.hash = '#LPRODUCTOS&p=1&t=TODO';
                        if (GetObjConfiguracion().busquedaActiva == "R")
                            GetObjControlador().navegarAPagina(GetObjConstantes()._REPRESENTADA, '#LREPRESENTADAS&p=1&t=TODO'); //window.location.hash = '#LREPRESENTADAS&p=1&t=TODO';
                        if (GetObjConfiguracion().busquedaActiva == "M")
                            GetObjControlador().navegarAPagina(GetObjConstantes()._MARCA, '#LMARCAS&p=1&t=TODO'); // window.location.hash = '#LMARCAS&p=1&t=TODO';
                        if (GetObjConfiguracion().busquedaActiva == "ST")
                            GetObjControlador().navegarAPagina(GetObjConstantes()._STAND, '#LSTANDS&p=1&t=TODO'); // window.location.hash = '#LSTANDS&p=1&t=TODO';
                        var filtroBusqueda = jQuery.inArray(GetObjConfiguracion().busquedaActiva, GetObjConfiguracion().arrayOpcionesBusqueda);
                        if (filtroBusqueda == -1) {
                            GetObjControlador().navegarAPagina(GetObjConstantes()._GENERICO, '#GEN&p=1&t=TODO&g=' + GetObjConfiguracion().busquedaActiva); // window.location.hash = '#GEN&p=1&t=TODO&g=' + GetObjConfiguracion().busquedaActiva;
                        }
                    }
                    else
                    {
                        if (GetObjConfiguracion().busquedaActiva == "S")
                            GetObjControlador().navegarAPagina(GetObjConstantes()._SECTOR, '#LSECTOR&p=1&t=TODO&s=' + GetObjConfiguracion().filtroBusquedaActiva); //window.location.hash = '#LSECTOR&p=1&t=EMPIEZAPOR&b=' + letraBusqueda + "&s=" + GetObjConfiguracion().filtroBusquedaActiva;
                        if (GetObjConfiguracion().busquedaActiva == "P")
                            GetObjControlador().navegarAPagina(GetObjConstantes()._PAIS, '#LPAISES&p=1&t=TODO&c=' + GetObjConfiguracion().filtroBusquedaActiva); //window.location.hash = '#LPAISES&p=1&t=EMPIEZAPOR&b=' + letraBusqueda + "&c=" + GetObjConfiguracion().filtroBusquedaActiva;
                        if (GetObjConfiguracion().busquedaActiva == "A")
                            GetObjControlador().navegarAPagina(GetObjConstantes()._ACTIVIDAD, '#LACTIVIDAD&p=1&t=TODO&a=' + GetObjConfiguracion().filtroBusquedaActiva); //window.location.hash = '#LACTIVIDAD&p=1&t=EMPIEZAPOR&b=' + letraBusqueda + "&a=" + GetObjConfiguracion().filtroBusquedaActiva;
                        if (GetObjConfiguracion().busquedaActiva == "O")
                            GetObjControlador().navegarAPagina(GetObjConstantes()._PRODUCTO, '#LPRODUCTOS&p=1&t=TODO&o=' + GetObjConfiguracion().filtroBusquedaActiva); //window.location.hash = '#LPRODUCTOS&p=1&t=EMPIEZAPOR&b=' + letraBusqueda + "&o=" + GetObjConfiguracion().filtroBusquedaActiva;
                        if (GetObjConfiguracion().busquedaActiva == "R")
                            GetObjControlador().navegarAPagina(GetObjConstantes()._REPRESENTADA, '#LREPRESENTADAS&p=1&t=TODO&r=' + GetObjConfiguracion().filtroBusquedaActiva); //window.location.hash = '#LREPRESENTADAS&p=1&t=EMPIEZAPOR&b=' + letraBusqueda + "&r=" + GetObjConfiguracion().filtroBusquedaActiva;
                        if (GetObjConfiguracion().busquedaActiva == "M")
                            GetObjControlador().navegarAPagina(GetObjConstantes()._MARCA, '#LMARCAS&p=1&t=TODO&m=' + GetObjConfiguracion().filtroBusquedaActiva); // window.location.hash = '#LMARCAS&p=1&t=EMPIEZAPOR&b=' + letraBusqueda + "&m=" + GetObjConfiguracion().filtroBusquedaActiva;
                        if (GetObjConfiguracion().busquedaActiva == "ST")
                            GetObjControlador().navegarAPagina(GetObjConstantes()._STAND, '#LSTANDS&p=1&t=TODO&st=' + GetObjConfiguracion().filtroBusquedaActiva); // window.location.hash = '#LSTANDS&p=1&t=EMPIEZAPOR&b=' + letraBusqueda + "&st=" + GetObjConfiguracion().filtroBusquedaActiva;
                        var filtroBusqueda = jQuery.inArray(GetObjConfiguracion().busquedaActiva, GetObjConfiguracion().arrayOpcionesBusqueda); //GetObjConfiguracion().arrayOpcionesBusqueda.indexOf(GetObjConfiguracion().busquedaActiva);
                        if (filtroBusqueda == -1) {
                            GetObjControlador().navegarAPagina(GetObjConstantes()._GENERICO, '#GEN&p=1&t=TODO&g=' + GetObjConfiguracion().busquedaActiva + "&s=" + GetObjConfiguracion().filtroBusquedaActiva); // window.location.hash = '#GEN&p=1&t=EMPIEZAPOR&b=' + letraBusqueda + "&g=" + GetObjConfiguracion().busquedaActiva + "&s=" + GetObjConfiguracion().filtroBusquedaActiva;
                        }
                    }
                }
            }
            else
            {
                if (GetObjConfiguracion().busquedaActiva == "T") {
                    GetObjControlador().navegarAPagina(GetObjConstantes()._LISTA, '#LEMPRESAS&p=1&t=EMPIEZAPOR&b=' + letraBusqueda); //window.location.hash = '#LEMPRESAS&p=1&t=EMPIEZAPOR&b=' + letraBusqueda;
                } else {
                    if (GetObjConfiguracion().filtroBusquedaActiva == "") {
                        if (GetObjConfiguracion().busquedaActiva == "S")
                            GetObjControlador().navegarAPagina(GetObjConstantes()._SECTOR, '#LSECTOR&p=1&t=EMPIEZAPOR&b=' + letraBusqueda); //window.location.hash = '#LSECTOR&p=1&t=EMPIEZAPOR&b=' + letraBusqueda;
                        if (GetObjConfiguracion().busquedaActiva == "P")
                            GetObjControlador().navegarAPagina(GetObjConstantes()._PAIS, '#LPAISES&p=1&t=EMPIEZAPOR&b=' + letraBusqueda); //window.location.hash = '#LPAISES&p=1&t=EMPIEZAPOR&b=' + letraBusqueda;
                        if (GetObjConfiguracion().busquedaActiva == "A")
                            GetObjControlador().navegarAPagina(GetObjConstantes()._ACTIVIDAD, '#LACTIVIDAD&p=1&t=EMPIEZAPOR&b=' + letraBusqueda);//window.location.hash = '#LACTIVIDAD&p=1&t=EMPIEZAPOR&b=' + letraBusqueda;
                        if (GetObjConfiguracion().busquedaActiva == "O")
                            GetObjControlador().navegarAPagina(GetObjConstantes()._PRODUCTO, '#LPRODUCTOS&p=1&t=EMPIEZAPOR&b=' + letraBusqueda); //window.location.hash = '#LPRODUCTOS&p=1&t=EMPIEZAPOR&b=' + letraBusqueda;
                        if (GetObjConfiguracion().busquedaActiva == "R")
                            GetObjControlador().navegarAPagina(GetObjConstantes()._REPRESENTADA, '#LREPRESENTADAS&p=1&t=EMPIEZAPOR&b=' + letraBusqueda); //window.location.hash = '#LREPRESENTADAS&p=1&t=EMPIEZAPOR&b=' + letraBusqueda;
                        if (GetObjConfiguracion().busquedaActiva == "M")
                            GetObjControlador().navegarAPagina(GetObjConstantes()._MARCA, '#LMARCAS&p=1&t=EMPIEZAPOR&b=' + letraBusqueda); // window.location.hash = '#LMARCAS&p=1&t=EMPIEZAPOR&b=' + letraBusqueda;
                        if (GetObjConfiguracion().busquedaActiva == "ST")
                            GetObjControlador().navegarAPagina(GetObjConstantes()._STAND, '#LSTANDS&p=1&t=EMPIEZAPOR&b=' + letraBusqueda); // window.location.hash = '#LSTANDS&p=1&t=EMPIEZAPOR&b=' + letraBusqueda;
                        var filtroBusqueda = jQuery.inArray(GetObjConfiguracion().busquedaActiva, GetObjConfiguracion().arrayOpcionesBusqueda);
                        if (filtroBusqueda == -1) {
                            GetObjControlador().navegarAPagina(GetObjConstantes()._GENERICO,'#GEN&p=1&t=EMPIEZAPOR&b=' + letraBusqueda + "&g=" + GetObjConfiguracion().busquedaActiva ); // window.location.hash = '#GEN&p=1&t=EMPIEZAPOR&b=' + letraBusqueda + "&g=" + GetObjConfiguracion().busquedaActiva;
                        }
                    }
                    else {
                        if (GetObjConfiguracion().busquedaActiva == "S")
                            GetObjControlador().navegarAPagina(GetObjConstantes()._SECTOR, '#LSECTOR&p=1&t=EMPIEZAPOR&b=' + letraBusqueda + "&s=" + GetObjConfiguracion().filtroBusquedaActiva); //window.location.hash = '#LSECTOR&p=1&t=EMPIEZAPOR&b=' + letraBusqueda + "&s=" + GetObjConfiguracion().filtroBusquedaActiva;
                        if (GetObjConfiguracion().busquedaActiva == "P")
                            GetObjControlador().navegarAPagina(GetObjConstantes()._PAIS, '#LPAISES&p=1&t=EMPIEZAPOR&b=' + letraBusqueda + "&c=" + GetObjConfiguracion().filtroBusquedaActiva); //window.location.hash = '#LPAISES&p=1&t=EMPIEZAPOR&b=' + letraBusqueda + "&c=" + GetObjConfiguracion().filtroBusquedaActiva;
                        if (GetObjConfiguracion().busquedaActiva == "A")
                            GetObjControlador().navegarAPagina(GetObjConstantes()._ACTIVIDAD, '#LACTIVIDAD&p=1&t=EMPIEZAPOR&b=' + letraBusqueda + "&a=" + GetObjConfiguracion().filtroBusquedaActiva); //window.location.hash = '#LACTIVIDAD&p=1&t=EMPIEZAPOR&b=' + letraBusqueda + "&a=" + GetObjConfiguracion().filtroBusquedaActiva;
                        if (GetObjConfiguracion().busquedaActiva == "O")
                            GetObjControlador().navegarAPagina(GetObjConstantes()._PRODUCTO, '#LPRODUCTOS&p=1&t=EMPIEZAPOR&b=' + letraBusqueda + "&o=" + GetObjConfiguracion().filtroBusquedaActiva); //window.location.hash = '#LPRODUCTOS&p=1&t=EMPIEZAPOR&b=' + letraBusqueda + "&o=" + GetObjConfiguracion().filtroBusquedaActiva;
                        if (GetObjConfiguracion().busquedaActiva == "R")
                            GetObjControlador().navegarAPagina(GetObjConstantes()._REPRESENTADA,'#LREPRESENTADAS&p=1&t=EMPIEZAPOR&b=' + letraBusqueda + "&r=" + GetObjConfiguracion().filtroBusquedaActiva ); //window.location.hash = '#LREPRESENTADAS&p=1&t=EMPIEZAPOR&b=' + letraBusqueda + "&r=" + GetObjConfiguracion().filtroBusquedaActiva;
                        if (GetObjConfiguracion().busquedaActiva == "M")
                            GetObjControlador().navegarAPagina(GetObjConstantes()._MARCA, '#LMARCAS&p=1&t=EMPIEZAPOR&b=' + letraBusqueda + "&m=" + GetObjConfiguracion().filtroBusquedaActiva); // window.location.hash = '#LMARCAS&p=1&t=EMPIEZAPOR&b=' + letraBusqueda + "&m=" + GetObjConfiguracion().filtroBusquedaActiva;
                        if (GetObjConfiguracion().busquedaActiva == "ST")
                            GetObjControlador().navegarAPagina(GetObjConstantes()._STANDS, '#LSTANDS&p=1&t=EMPIEZAPOR&b=' + letraBusqueda + "&st=" + GetObjConfiguracion().filtroBusquedaActiva); // window.location.hash = '#LSTANDS&p=1&t=EMPIEZAPOR&b=' + letraBusqueda + "&st=" + GetObjConfiguracion().filtroBusquedaActiva;
                        var filtroBusqueda = jQuery.inArray(GetObjConfiguracion().busquedaActiva, GetObjConfiguracion().arrayOpcionesBusqueda); //GetObjConfiguracion().arrayOpcionesBusqueda.indexOf(GetObjConfiguracion().busquedaActiva);
                        if (filtroBusqueda == -1) {
                            GetObjControlador().navegarAPagina(GetObjConstantes()._GENERICO, '#GEN&p=1&t=EMPIEZAPOR&b=' + letraBusqueda + "&g=" + GetObjConfiguracion().busquedaActiva + "&s=" + GetObjConfiguracion().filtroBusquedaActiva); // window.location.hash = '#GEN&p=1&t=EMPIEZAPOR&b=' + letraBusqueda + "&g=" + GetObjConfiguracion().busquedaActiva + "&s=" + GetObjConfiguracion().filtroBusquedaActiva;
                        }
                    }
                }
            }
        });

        $("#numeroResultados a").click(function (e) {
            e.preventDefault();
            var numeroResultados = $(this).attr('id');
            that.activarNumeroEmpresasFiltrar(numeroResultados);
            GetObjConfiguracion().actualizarNumPaginaEmpresas(numeroResultados);
            if (GetObjConfiguracion().busquedaActiva == "T") {
                GetObjControlador().navegarAPagina(GetObjConstantes()._LISTA, '#LEMPRESAS&e=' + numeroResultados); //window.location.hash = '#LEMPRESAS&e=' + numeroResultados;
            }
            if (GetObjConfiguracion().busquedaActiva == "S") {
                GetObjControlador().navegarAPagina(GetObjConstantes()._SECTOR, '#LSECTOR&e=' + numeroResultados + "&s=" + GetObjConfiguracion().filtroBusquedaActiva); //window.location.hash = '#LSECTOR&e=' + numeroResultados + "&s=" + GetObjConfiguracion().filtroBusquedaActiva;
            }
            if (GetObjConfiguracion().busquedaActiva == "P") {
                GetObjControlador().navegarAPagina(GetObjConstantes()._PAIS, '#LPAISES&e=' + numeroResultados + "&c=" + GetObjConfiguracion().filtroBusquedaActiva); //window.location.hash = '#LPAISES&e=' + numeroResultados + "&c=" + GetObjConfiguracion().filtroBusquedaActiva;
            }
            if (GetObjConfiguracion().busquedaActiva == "A") {
                GetObjControlador().navegarAPagina(GetObjConstantes()._ACTIVIDAD, '#LACTIVIDAD&e=' + numeroResultados + "&a=" + GetObjConfiguracion().filtroBusquedaActiva);//window.location.hash = '#LACTIVIDAD&e=' + numeroResultados + "&a=" + GetObjConfiguracion().filtroBusquedaActiva;
            }
            if (GetObjConfiguracion().busquedaActiva == "O") {
                GetObjControlador().navegarAPagina(GetObjConstantes()._PRODUCTO, '#LPRODUCTOS&e=' + numeroResultados + "&o=" + GetObjConfiguracion().filtroBusquedaActiva); //window.location.hash = '#LPRODUCTOS&e=' + numeroResultados + "&o=" + GetObjConfiguracion().filtroBusquedaActiva;
            }
            if (GetObjConfiguracion().busquedaActiva == "R") {
                GetObjControlador().navegarAPagina(GetObjConstantes()._REPRESENTADA, '#LREPRESENTADAS&e=' + numeroResultados + "&r=" + GetObjConfiguracion().filtroBusquedaActiva); //window.location.hash = '#LREPRESENTADAS&e=' + numeroResultados + "&r=" + GetObjConfiguracion().filtroBusquedaActiva;
            }
            if (GetObjConfiguracion().busquedaActiva == "M") {
                GetObjControlador().navegarAPagina(GetObjConstantes()._MARCA, '#LMARCAS&e=' + numeroResultados + "&m=" + GetObjConfiguracion().filtroBusquedaActiva); // window.location.hash = '#LMARCAS&e=' + numeroResultados + "&m=" + GetObjConfiguracion().filtroBusquedaActiva;
            }
            if (GetObjConfiguracion().busquedaActiva == "ST") {
                GetObjControlador().navegarAPagina(GetObjConstantes()._STAND, '#LSTANDS&e=' + numeroResultados + "&st=" + GetObjConfiguracion().filtroBusquedaActiva); // window.location.hash = '#LSTANDS&e=' + numeroResultados + "&st=" + GetObjConfiguracion().filtroBusquedaActiva;
            }
            var filtroBusqueda = jQuery.inArray(GetObjConfiguracion().busquedaActiva, GetObjConfiguracion().arrayOpcionesBusqueda);  //GetObjConfiguracion().arrayOpcionesBusqueda.indexOf(GetObjConfiguracion().busquedaActiva);
            if (filtroBusqueda == -1) {
                GetObjControlador().navegarAPagina(GetObjConstantes()._GENERICO, '#GEN&e=' + numeroResultados + "&g="+GetObjConfiguracion().busquedaActiva+"&s=" + GetObjConfiguracion().filtroBusquedaActiva); // window.location.hash = '#GEN&e=' + numeroResultados + "&g="+GetObjConfiguracion().busquedaActiva+"&s=" + GetObjConfiguracion().filtroBusquedaActiva;
            }
        });

        $("#numeroResultadosFavoritos a").click(function (e) {
            e.preventDefault();
            var numeroResultados = $(this).attr('id');
            that.activarNumeroEmpresasFiltrarFavoritos(numeroResultados);
            GetObjConfiguracion().numPagina = 1;
            GetObjControlador().cargarListaEmpresasFavoritas();
        });

        $("#btnTodasEmpresas").click(function () {
            CatalogoWebUI.setFlagOpcionElegida(false);
            CatalogoWebUI.setCriterioElegido("");
            GetObjListaEmpresas().limpiarFiltroPais();
            that.setBusquedaActiva("#btnTodasEmpresas");
            GetObjControlador().navegarAPagina(GetObjConstantes()._LISTA, '#LEMPRESAS&p=1&t=TODO'); //window.location.hash = '#LEMPRESAS&p=1&t=TODO';
            CatalogoWebUI.setPrinterVisible(true);
        });

        $("#PanelBusquedas button").each(function () {
            if ($(this).height() > 20) {
                $(this).css({ 'font-size': '12px'});
            }
        });
                
    }


    this.eventosBusquedaCruzada = function () {

        var accentMap = {
            "á": "a",
            "Á": "A",
            "é": "e",
            "É": "E",
            "í": "i",
            "Í": "I",
            "ó": "o",
            "Ó": "O",
            "ú": "u",
            "Ú": "U"
        };
        var normalize = function (term) {
            var ret = "";
            for (var i = 0; i < term.length; i++) {
                ret += accentMap[term.charAt(i)] || term.charAt(i);
            }
            return ret;
        };
        
        $("#busquedaCruzada").autocomplete({
        

            source: function( request, response ) {
                var matcher = new RegExp( $.ui.autocomplete.escapeRegex( request.term ), "i" );
                response($.grep(GetObjConfiguracion().arrayPaises, function (value) {
                    value = value.label || value.value || value;
                    return matcher.test( value ) || matcher.test( normalize( value ) );
                }) );
            },

            select: function (event, ui) {
                event.preventDefault();
                $("#busquedaCruzada").val(ui.item.label);
                GetObjConfiguracion().paisId = ui.item.value;
                GetObjListaEmpresas().actualizarImagenFiltro($("#busquedaCruzada"), $('#imgFiltrar'));
                var textBuscar = encodeURIComponent($('#busquedaNormal').val());
                GetObjListaEmpresas().buscarTexto(textBuscar);
            },
            focus: function (event, ui) {
                event.preventDefault();
                $("#busquedaCruzada").val(ui.item.label);
                GetObjListaEmpresas().actualizarImagenFiltro($("#busquedaCruzada"), $('#imgFiltrar'));
            }
        });

        $("#busquedaCruzada").keydown(function (e) {
            if (e.keyCode == $.ui.keyCode.TAB || e.keyCode == $.ui.keyCode.ENTER) {
                e.keyCode = $.ui.keyCode.DOWN;
                $(this).trigger(e);
                $("#btnFiltrar").focus();
            }
        });

        $("#busquedaCruzada").blur(function () {
            var trimValue = $.trim($("#busquedaCruzada").val().toUpperCase());
            if (trimValue.length > 0) {
                var allowedValues = GetObjConfiguracion().arrayPaises;
                var valueExists = false;
                for (var i = 0, len = allowedValues.length; i < len; i++) {
                    if (trimValue == allowedValues[i].label) {
                        $("#busquedaCruzada").val(trimValue);
                        GetObjConfiguracion().paisId = allowedValues[i].value;
                        valueExists = true;
                        break;
                    }
                }
                if (!valueExists) {
                    for (var i = 0, len = allowedValues.length; i < len; i++) {
                        if (allowedValues[i].label.indexOf(trimValue) >= 0) {
                            $("#busquedaCruzada").val(allowedValues[i].label);
                            GetObjConfiguracion().paisId = allowedValues[i].value;
                            valueExists = true;
                            break;
                        }
                    }
                }
                if (!valueExists) {
                    //$("#busquedaCruzada").val("");
                    GetObjConfiguracion().paisId = "NO_LST";
                }
            } else {
                $("#busquedaCruzada").val("");
                GetObjConfiguracion().paisId = "";
            }
            
            GetObjListaEmpresas().actualizarImagenFiltro($("#busquedaCruzada"), $('#imgFiltrar'));
            var textBuscar = encodeURIComponent($('#busquedaNormal').val());
            GetObjListaEmpresas().buscarTexto(textBuscar);
        });

        $("#btnFiltrar").click(function () {
            $("#busquedaCruzada").val("");
            GetObjConfiguracion().paisId = "";
            GetObjListaEmpresas().actualizarImagenFiltro($("#busquedaCruzada"), $('#imgFiltrar'));
            $("#busquedaCruzada").focus();

            var textBuscar = encodeURIComponent($('#busquedaNormal').val());
            GetObjListaEmpresas().buscarTexto(textBuscar);
        });

        $("#busquedaCruzadaMovil").autocomplete({

            //source: GetObjConfiguracion().arrayPaises,
            source: function (request, response) {
                var matcher = new RegExp($.ui.autocomplete.escapeRegex(request.term), "i");
                response($.grep(GetObjConfiguracion().arrayPaises, function (value) {
                    value = value.label || value.value || value;
                    return matcher.test(value) || matcher.test(normalize(value));
                }));
            },

            select: function (event, ui) {
                event.preventDefault();
                $("#busquedaCruzadaMovil").val(ui.item.label);
                GetObjConfiguracion().paisId = ui.item.value;
                GetObjListaEmpresas().actualizarImagenFiltroMovil($("#busquedaCruzadaMovil"), $('#btnFiltrarMovil'));

                var textBuscar = encodeURIComponent($('#txtBuscarMovil').val());
                GetObjListaEmpresas().buscarTexto(textBuscar);
            },
            focus: function (event, ui) {
                event.preventDefault();
                $("#busquedaCruzadaMovil").val(ui.item.label);
                GetObjListaEmpresas().actualizarImagenFiltroMovil($("#busquedaCruzadaMovil"), $('#btnFiltrarMovil'));
            }
        });

        $("#busquedaCruzadaMovil").keydown(function (e) {
            if (e.keyCode == $.ui.keyCode.TAB || e.keyCode == $.ui.keyCode.ENTER) {
                e.keyCode = $.ui.keyCode.DOWN;
                $(this).trigger(e);
                $("#btnFiltrarMovil").focus();
            }
        });

        $("#busquedaCruzadaMovil").blur(function () {
            var trimValue = $.trim($("#busquedaCruzadaMovil").val().toUpperCase());
            if (trimValue.length > 0) {
                var allowedValues = GetObjConfiguracion().arrayPaises;
                var valueExists = false;
                for (var i = 0, len = allowedValues.length; i < len; i++) {
                    if (trimValue == allowedValues[i].label) {
                        $("#busquedaCruzadaMovil").val(trimValue);
                        GetObjConfiguracion().paisId = allowedValues[i].value;
                        valueExists = true;
                        break;
                    }
                }
                if (!valueExists) {
                    for (var i = 0, len = allowedValues.length; i < len; i++) {
                        if (allowedValues[i].label.indexOf(trimValue) >= 0) {
                            $("#busquedaCruzadaMovil").val(allowedValues[i].label);
                            GetObjConfiguracion().paisId = allowedValues[i].value;
                            valueExists = true;
                            break;
                        }
                    }
                }
                if (!valueExists) {
                    //$("#busquedaCruzadaMovil").val("");
                    GetObjConfiguracion().paisId = "NO_LST";
                }
            } else {
                $("#busquedaCruzadaMovil").val("");
                GetObjConfiguracion().paisId = "";
            }
            GetObjListaEmpresas().actualizarImagenFiltroMovil($("#busquedaCruzadaMovil"), $('#btnFiltrarMovil'));
            var textBuscar = encodeURIComponent($('#txtBuscarMovil').val());
            GetObjListaEmpresas().buscarTexto(textBuscar);
        });

        $("#btnFiltrarMovil").click(function () {
            $("#busquedaCruzadaMovil").val("");
            GetObjConfiguracion().paisId = "";
            GetObjListaEmpresas().actualizarImagenFiltroMovil($("#busquedaCruzadaMovil"), $('#btnFiltrarMovil'));
            $("#busquedaCruzadaMovil").focus();

            var textBuscar = encodeURIComponent($('#txtBuscarMovil').val());
            GetObjListaEmpresas().buscarTexto(textBuscar);
        });
    }

    this.eventosMenuMovil = function () {
        $("#menuMovil a").click(function (e) {
            e.preventDefault();
            var opcionSeleccionada = $(this).attr('tipo');

            $('#txtBuscarMovil').val("");
            GetObjListaEmpresas().limpiarFiltroPaisMovil();
            CatalogoWebUI.setCriterioElegido(opcionSeleccionada);
            CatalogoWebUI.setFlagOpcionElegida(false);
            // Si visita favoritos o mapa al igual que en web se borran los filtros.
            GetObjConfiguracion().busquedaActiva = 'T';

            if (opcionSeleccionada != undefined) {
                $("#menuMovil li").each(function (ele) {
                    $(this).removeClass("active");
                });
                $(this).parent().addClass("active");
                if (opcionSeleccionada == 'P')
                    GetObjControlador().navegarAPagina(GetObjConstantes()._PAIS, '#LPAISES&p=1'); //window.location.hash = '#LPAISES&p=1';

                if (opcionSeleccionada == 'T') {
                    GetObjControlador().navegarAPagina(GetObjConstantes()._LISTA, '#LEMPRESAS&p=1&t=TODO');//window.location.hash = '#LEMPRESAS&p=1&t=TODO';
                }

                if (opcionSeleccionada == 'S')
                    GetObjControlador().navegarAPagina(GetObjConstantes()._SECTOR, '#LSECTOR&p=1&e=' + GetObjConfiguracion().numEmpresas); //window.location.hash = '#LSECTOR&p=1&e=' + GetObjConfiguracion().numEmpresas;

                if (opcionSeleccionada == 'A')
                    GetObjControlador().navegarAPagina(GetObjConstantes()._ACTIVIDAD, '#LACTIVIDAD&p=1&e=' + GetObjConfiguracion().numEmpresas); //window.location.hash = '#LACTIVIDAD&p=1&e=' + GetObjConfiguracion().numEmpresas;

                if (opcionSeleccionada == 'O')
                    GetObjControlador().navegarAPagina(GetObjConstantes()._PRODUCTO, '#LPRODUCTOS&p=1&e=' + GetObjConfiguracion().numEmpresas); //window.location.hash = '#LPRODUCTOS&p=1&e=' + GetObjConfiguracion().numEmpresas;

                if (opcionSeleccionada == 'R')
                    GetObjControlador().navegarAPagina(GetObjConstantes()._REPRESENTADA, '#LREPRESENTADAS&p=1&e=' + GetObjConfiguracion().numEmpresas); //window.location.hash = '#LREPRESENTADAS&p=1&e=' + GetObjConfiguracion().numEmpresas;

                if (opcionSeleccionada == 'M')
                    GetObjControlador().navegarAPagina(GetObjConstantes()._MARCA, '#LMARCAS&p=1&e=' + GetObjConfiguracion().numEmpresas); // window.location.hash = '#LMARCAS&p=1&e=' + GetObjConfiguracion().numEmpresas;

                if (opcionSeleccionada == 'ST')
                    GetObjControlador().navegarAPagina(GetObjConstantes()._STAND, '#LSTANDS&p=1&e=' + GetObjConfiguracion().numEmpresas); // window.location.hash = '#LSTANDS&p=1&e=' + GetObjConfiguracion().numEmpresas;

                if (opcionSeleccionada == 'MAPA')
                    GetObjControlador().navegarAPagina(GetObjConstantes()._MAPA_FERIA, '#MAPA_FERIA'); //window.location.hash = '#MAPA_FERIA';

                if (opcionSeleccionada == 'F') {
                    //GetObjListaEmpresas().activarNumeroEmpresasFiltrarFavoritos("F_10");
                    //GetObjConfiguracion().actualizarFiltrosBusquedaListaEmpresas("", 1, 10, "CONTIENE", "madrid"); //TODO (FAVORITOS, GetFavoritos().obtenerListaFavoritos()) ..  ... en la version final será , 
                    GetObjControlador().navegarAPagina(GetObjConstantes()._FAVORITOS, '#FAVORITOS&p=1'); //window.location.hash = '#FAVORITOS&p=1';
                }

                var filtroBusqueda = jQuery.inArray(opcionSeleccionada, GetObjConfiguracion().arrayOpcionesBusqueda); //GetObjConfiguracion().arrayOpcionesBusqueda.indexOf(opcionSeleccionada);
                if (filtroBusqueda == -1)
                    GetObjControlador().navegarAPagina(GetObjConstantes()._GENERICO, '#GEN&p=1&e=' + GetObjConfiguracion().numEmpresas + '&g=' + opcionSeleccionada); // window.location.hash = '#GEN&p=1&e=' + GetObjConfiguracion().numEmpresas + '&g=' + opcionSeleccionada;
            }

        });
    }
       

    this.setBusquedaActiva = function (idBtnActivo) {
        //T - todas las empresas, P - paises, S - Sectores, A - actividad, M - marcas, R - repre, O - Productos
        $("#menuOpcionesBusqueda button").each(function (ele) {
            $(this).removeClass("btn-primary");
            $(this).addClass("btn-default");
        });

        if (GetObjConfiguracion().tipoBusqueda != "CONTIENE") {
            $("#busquedaNormal").val("");
        }

        $("#PanelBusquedas " + idBtnActivo).removeClass("btn-default");
        $("#PanelBusquedas " + idBtnActivo).addClass("btn-primary");
        $("#PanelBusquedas " + idBtnActivo).focus();
    }

    this.clickOpcionMenu = function (ele) {
        if (ele != undefined) {
            CatalogoWebUI.setFlagOpcionElegida(false);
            CatalogoWebUI.setCriterioElegido(ko.dataFor(ele).tipo);
            that.setBusquedaActiva("#" + ko.dataFor(ele).tipo);
            if (ko.dataFor(ele).tipo == "T")
                CatalogoWebUI.setPrinterVisible(true);
            else
                CatalogoWebUI.setPrinterVisible(false);

            if (ko.dataFor(ele).tipo == "T")
            {
                GetObjControlador().navegarAPagina(GetObjConstantes()._LISTA, '#LEMPRESAS&p=1&t=TODO'); //window.location.hash = '#LEMPRESAS&p=1&t=TODO';
            }
            else
            {
                if (ko.dataFor(ele).tipo == "M")
                    GetObjControlador().navegarAPagina(GetObjConstantes()._MARCA, '#LMARCAS&p=1&e=' + GetObjConfiguracion().numEmpresas); // window.location.hash = '#LMARCAS&p=1&e=' + GetObjConfiguracion().numEmpresas;
                else if (ko.dataFor(ele).tipo == "ST")
                    GetObjControlador().navegarAPagina(GetObjConstantes()._STAND, '#LSTANDS&p=1&e=' + GetObjConfiguracion().numEmpresas); // window.location.hash = '#LSTANDS&p=1&e=' + GetObjConfiguracion().numEmpresas;
                else if (ko.dataFor(ele).tipo == "R")
                    GetObjControlador().navegarAPagina(GetObjConstantes()._REPRESENTADA, '#LREPRESENTADAS&p=1&e=' + GetObjConfiguracion().numEmpresas); //window.location.hash = '#LREPRESENTADAS&p=1&e=' + GetObjConfiguracion().numEmpresas;
                else if (ko.dataFor(ele).tipo == "O")
                    GetObjControlador().navegarAPagina(GetObjConstantes()._PRODUCTO, '#LPRODUCTOS&p=1&e=' + GetObjConfiguracion().numEmpresas); //window.location.hash = '#LPRODUCTOS&p=1&e=' + GetObjConfiguracion().numEmpresas;
                else if (ko.dataFor(ele).tipo == "A")
                    GetObjControlador().navegarAPagina(GetObjConstantes()._ACTIVIDAD, '#LACTIVIDAD&p=1&e=' + GetObjConfiguracion().numEmpresas); //window.location.hash = '#LACTIVIDAD&p=1&e=' + GetObjConfiguracion().numEmpresas;
                else if (ko.dataFor(ele).tipo == "S")
                    GetObjControlador().navegarAPagina(GetObjConstantes()._SECTOR, '#LSECTOR&p=1&e=' + GetObjConfiguracion().numEmpresas);//window.location.hash = '#LSECTOR&p=1&e=' + GetObjConfiguracion().numEmpresas;
                else if (ko.dataFor(ele).tipo == "P")
                    GetObjControlador().navegarAPagina(GetObjConstantes()._PAIS, '#LPAISES&p=1&e=' + GetObjConfiguracion().numEmpresas); //window.location.hash = '#LPAISES&p=1&e=' + GetObjConfiguracion().numEmpresas;
                else
                    GetObjControlador().navegarAPagina(GetObjConstantes()._GENERICO, '#GEN&p=1&e=' + GetObjConfiguracion().numEmpresas + '&g=' + ko.dataFor(ele).tipo); // window.location.hash = '#GEN&p=1&e=' + GetObjConfiguracion().numEmpresas + '&g=' + ko.dataFor(ele).tipo;

                GetObjListaEmpresas().limpiarFiltroPais();
            }
        }
    }

    this.buscarTexto = function (textBuscar) {
        var tipo, url;

        // Caso generico.
        var filtroBusqueda = jQuery.inArray(GetObjConfiguracion().busquedaActiva,
            GetObjConfiguracion().arrayOpcionesBusqueda);

        if (GetObjConfiguracion().busquedaActiva == "T") {
            tipo = GetObjConstantes()._LISTA;
            url = '#LEMPRESAS&p=1';
        } else if (GetObjConfiguracion().busquedaActiva == "S") {
            tipo = GetObjConstantes()._SECTOR;
            url = '#LSECTOR&p=1';
            if (GetObjConfiguracion().filtroBusquedaActiva != "") {
                url += "&s=" + GetObjConfiguracion().filtroBusquedaActiva;
            }
        } else if (GetObjConfiguracion().busquedaActiva == "P") {
            tipo = GetObjConstantes()._PAIS;
            url = '#LPAISES&p=1';
            if (GetObjConfiguracion().filtroBusquedaActiva != "") {
                url += "&c=" + GetObjConfiguracion().filtroBusquedaActiva;
            }
        } else if (GetObjConfiguracion().busquedaActiva == "A") {
            tipo = GetObjConstantes()._ACTIVIDAD;
            url = '#LACTIVIDAD&p=1';
            if (GetObjConfiguracion().filtroBusquedaActiva != "") {
                url += "&a=" + GetObjConfiguracion().filtroBusquedaActiva;
            }
        } else if (GetObjConfiguracion().busquedaActiva == "O") {
            tipo = GetObjConstantes()._PRODUCTO;
            url = '#LPRODUCTOS&p=1';
            if (GetObjConfiguracion().filtroBusquedaActiva != "") {
                url += "&o=" + GetObjConfiguracion().filtroBusquedaActiva;
            }
        } else if (GetObjConfiguracion().busquedaActiva == "R") {
            tipo = GetObjConstantes()._REPRESENTADA;
            url = '#LREPRESENTADAS&p=1';
            if (GetObjConfiguracion().filtroBusquedaActiva != "") {
                url += "&r=" + GetObjConfiguracion().filtroBusquedaActiva;
            }
        } else if (GetObjConfiguracion().busquedaActiva == "M") {
            tipo = GetObjConstantes()._MARCA;
            url = '#LMARCAS&p=1';
            if (GetObjConfiguracion().filtroBusquedaActiva != "") {
                url += "&m=" + GetObjConfiguracion().filtroBusquedaActiva;
            }
        } else if (GetObjConfiguracion().busquedaActiva == "ST") {
            tipo = GetObjConstantes()._STAND;
            url = '#LSTANDS&p=1';
            if (GetObjConfiguracion().filtroBusquedaActiva != "") {
                url += "&st=" + GetObjConfiguracion().filtroBusquedaActiva;
            }
        } else if (filtroBusqueda == -1) {
            tipo = GetObjConstantes()._GENERICO;
            url = '#GEN&p=1&g=' + GetObjConfiguracion().busquedaActiva;
            if (GetObjConfiguracion().filtroBusquedaActiva != "") {
                url += "&s=" + GetObjConfiguracion().filtroBusquedaActiva;
            }
        }

        // Busqueda normal.
        if (textBuscar != undefined && textBuscar.length > 0) {
            url += '&t=CONTIENE&b=' + textBuscar;
        }
        else {
            url += '&t=TODO';
        }

        // Busqueda cruzada.
        // Incluyendo este valor conseguimos lanzar el evento 'window.onhashchange'.
        var paisId = $.trim(GetObjConfiguracion().paisId);
        if (paisId != "") {
            url += "&PaisId=" + GetObjConfiguracion().paisId;
        }

        GetObjControlador().navegarAPagina(tipo, url);
    }
    
    this.activarBtnTodasEmpresas = function () {
      //  that.setBusquedaActiva("#btnTodasEmpresas");
        //that.activarNumeroEmpresasFiltrar(GetObjConfiguracion().numEmpresas);
        GetObjConfiguracion().busquedaActiva = 'T';
        $("#ListaIndiceBusquedaSimple").hide();
        //DDC hay incoherencia con la lista de empresas$("#10").show();
        //$("#letraTodos").hide();
        $("#filtroNumeroResultados").show();
        $("#ListaEmpresasTodasEmpresas").show();
    }

    this.activarBtnSector = function () {
      //  that.setBusquedaActiva("#btnSector");
        GetObjConfiguracion().busquedaActiva = 'S';
        $("#ListaIndiceBusquedaSimple").show();
        //DDC hay incoherencia con la lista de empresas$("#10").show();
        //that.activarNumeroEmpresasFiltrar("20");
        //$("#letraTodos").show();
        //$("#filtroNumeroResultados").hide();
        $("#ListaEmpresasTodasEmpresas").hide();
        CatalogoWebUI.tituloIndice(CatalogoWebUI.language().tituloIndiceSector);
        GetObjConfiguracion().actualizarFiltrosBusquedaListaEmpresas("", 1, GetObjConfiguracion().numEmpresas, "TODO", "");
        //that.activarNumeroEmpresasFiltrar(GetObjConfiguracion().numEmpresas);
    }

    this.activarBtnPais = function () {
       // that.setBusquedaActiva("#btnPais");
        GetObjConfiguracion().busquedaActiva = 'P';
        $("#ListaIndiceBusquedaSimple").show();
        //DDC hay incoherencia con la lista de empresas$("#10").show();
        //that.activarNumeroEmpresasFiltrar("20");
        //$("#letraTodos").show();
        //$("#filtroNumeroResultados").hide();
        $("#ListaEmpresasTodasEmpresas").hide();
        CatalogoWebUI.tituloIndice(CatalogoWebUI.language().tituloIndicePais);
        GetObjConfiguracion().actualizarFiltrosBusquedaListaEmpresas("", 1, GetObjConfiguracion().numEmpresas, "TODO", "");
    }

    this.activarBtnGenerico = function (idGen) {
        // that.setBusquedaActiva("#btnPais");
        GetObjConfiguracion().busquedaActiva = idGen;
        $("#ListaIndiceBusquedaSimple").show();
        //DDC hay incoherencia con la lista de empresas$("#10").show();
        //that.activarNumeroEmpresasFiltrar("20");
        //$("#letraTodos").show();
        //$("#filtroNumeroResultados").hide();
        $("#ListaEmpresasTodasEmpresas").hide();
        CatalogoWebUI.tituloIndice(CatalogoWebUI.getTituloGenerico(idGen));
        GetObjConfiguracion().actualizarFiltrosBusquedaListaEmpresas("", 1, GetObjConfiguracion().numEmpresas, "TODO", "");
    }

    this.activarBtnActividad = function () {
       // that.setBusquedaActiva("#btnActividad");
        GetObjConfiguracion().busquedaActiva = 'A';
        $("#ListaIndiceBusquedaSimple").show();
        //DDC hay incoherencia con la lista de empresas$("#10").show();
        //that.activarNumeroEmpresasFiltrar("20");
        //$("#letraTodos").show();
        //$("#filtroNumeroResultados").hide();
        $("#ListaEmpresasTodasEmpresas").hide();
        CatalogoWebUI.tituloIndice(CatalogoWebUI.language().tituloActividad);
        GetObjConfiguracion().actualizarFiltrosBusquedaListaEmpresas("", 1, GetObjConfiguracion().numEmpresas, "TODO", "");
    }

    this.activarBtnProducto = function () {
       // that.setBusquedaActiva("#btnProductos");
        GetObjConfiguracion().busquedaActiva = 'O';
        $("#ListaIndiceBusquedaSimple").show();
        //DDC hay incoherencia con la lista de empresas$("#10").show();
        //that.activarNumeroEmpresasFiltrar("20");
       // $("#letraTodos").show();
        //$("#filtroNumeroResultados").hide();
        $("#ListaEmpresasTodasEmpresas").hide();
        CatalogoWebUI.tituloIndice(CatalogoWebUI.language().tituloProducto);
        GetObjConfiguracion().actualizarFiltrosBusquedaListaEmpresas("", 1, GetObjConfiguracion().numEmpresas, "TODO", "");
    }

    this.activarBtnRepresentadas = function () {
      //  that.setBusquedaActiva("#btnRepresentadas");
        GetObjConfiguracion().busquedaActiva = 'R';
        $("#ListaIndiceBusquedaSimple").show();
        //DDC hay incoherencia con la lista de empresas$("#10").show();
        //that.activarNumeroEmpresasFiltrar("20");
       // $("#letraTodos").show();
        //$("#filtroNumeroResultados").hide();
        $("#ListaEmpresasTodasEmpresas").hide();
        CatalogoWebUI.tituloIndice(CatalogoWebUI.language().tituloIndiceRepresentadas);
        GetObjConfiguracion().actualizarFiltrosBusquedaListaEmpresas("", 1, GetObjConfiguracion().numEmpresas, "TODO", "");
    }

    this.activarBtnMarcas = function () {
       // that.setBusquedaActiva("#btnMarcas");
        GetObjConfiguracion().busquedaActiva = 'M';
        $("#ListaIndiceBusquedaSimple").show();
        //DDC hay incoherencia con la lista de empresas$("#10").show();
        //that.activarNumeroEmpresasFiltrar("20");
        //$("#letraTodos").show();
        //$("#filtroNumeroResultados").hide();
        $("#ListaEmpresasTodasEmpresas").hide();
        CatalogoWebUI.tituloIndice(CatalogoWebUI.language().tituloIndiceMarcas);
        GetObjConfiguracion().actualizarFiltrosBusquedaListaEmpresas("", 1, GetObjConfiguracion().numEmpresas, "TODO", "");
    }

    this.activarBtnStands = function () {
        GetObjConfiguracion().busquedaActiva = 'ST';
        $("#ListaIndiceBusquedaSimple").show();
        $("#ListaEmpresasTodasEmpresas").hide();
        CatalogoWebUI.tituloIndice(CatalogoWebUI.language().tituloIndiceStands);
        GetObjConfiguracion().actualizarFiltrosBusquedaListaEmpresas("", 1, GetObjConfiguracion().numEmpresas, "TODO", "");
    }

    this.activarNumeroEmpresasFiltrar = function (numEmpresaFiltro) {
        $("#10").removeClass("numEmpresasActiva");
        $("#20").removeClass("numEmpresasActiva");
        $("#50").removeClass("numEmpresasActiva");
        $("#100").removeClass("numEmpresasActiva");
        $("#" + numEmpresaFiltro).addClass("numEmpresasActiva");
        
    }

    this.activarNumeroEmpresasFiltrarFavoritos = function (numEmpresaFiltro) {

        if (numEmpresaFiltro != undefined) {
            var res = numEmpresaFiltro.split("_");
            var numEmpresas = res[1];
            $("#F_10").removeClass("numEmpresasActiva");
            $("#F_20").removeClass("numEmpresasActiva");
            $("#F_50").removeClass("numEmpresasActiva");
            $("#F_100").removeClass("numEmpresasActiva");
            $("#F_TODOS").removeClass("numEmpresasActiva");
            $("#F_" + numEmpresas).addClass("numEmpresasActiva");
            /*DDC lo quito no tiene sentido        if (numEmpresas == "TODOS") {
                        $("#lblTodosResultados").removeClass("lblNormal");
                        GetObjConfiguracion().numEmpresas = 999;
                    }
                    else {*/
            $("#lblTodosResultados").addClass("lblNormal");
            GetObjConfiguracion().numEmpresas = numEmpresas;
            //}
        }
    }
    
    this.saveAnalyticsSR = function (ele) {
        if (ele != undefined) {
            GetObjControlador().saveAnalyticsOtros("SERVICIO DE REUNIONES", ko.dataFor(ele).nombre);
        }
    }

    this.saveAnalytics = function (ele) {
        if (ele != undefined) {
            GetObjControlador().saveAnalyticsOtros("WEB EMPRESA", ko.dataFor(ele).nombre);
        }
    }

    this.irAMapa = function (ele) {
        if (ele != undefined) {
            GetObjConfiguracion().nombreEmpresa = ko.dataFor(ele).nombre;
            GetObjControlador().navegarAPagina(GetObjConstantes()._MAPA_FERIA, ko.dataFor(ele).plano);//window.location.hash = ko.dataFor(ele).plano;
        }
    }

    this.irAFichaEmpresa = function (ele) {
        if (ele != undefined) {
            GetObjControlador().navegarAPagina(GetObjConstantes()._FICHA, ko.dataFor(ele).fichaEmpresa);//window.location.hash = ko.dataFor(ele).fichaEmpresa;
        }
    }

    this.irAListaEmpresa = function (ele) {
        $('#busquedaNormal').val("");
        GetObjListaEmpresas().limpiarFiltroPais();
        $('#txtBuscarMovil').val("");
        GetObjListaEmpresas().limpiarFiltroPaisMovil();
        GetObjConfiguracion().textoBusqueda = "";
        if (ele != undefined) {
            var opcionIndice = ko.dataFor(ele).link;
            if (opcionIndice.search("#LSECTOR") >= 0)
                GetObjControlador().navegarAPagina(GetObjConstantes()._SECTOR, opcionIndice);
            if (opcionIndice.search("#LPAISES") >= 0)
                GetObjControlador().navegarAPagina(GetObjConstantes()._PAIS, opcionIndice);    
            if (opcionIndice.search("#LACTIVIDAD") >= 0)
                GetObjControlador().navegarAPagina(GetObjConstantes()._ACTIVIDAD, opcionIndice); 
            if (opcionIndice.search("#LPRODUCTOS") >= 0)
                GetObjControlador().navegarAPagina(GetObjConstantes()._PRODUCTO, opcionIndice); 
            if (opcionIndice.search("#LREPRESENTADAS") >= 0)
                GetObjControlador().navegarAPagina(GetObjConstantes()._REPRESENTADA, opcionIndice);
            if (opcionIndice.search("#LMARCAS") >= 0)
                GetObjControlador().navegarAPagina(GetObjConstantes()._MARCA, opcionIndice);
            if (opcionIndice.search("#LSTANDS") >= 0)
                GetObjControlador().navegarAPagina(GetObjConstantes()._STAND, opcionIndice);
            if (opcionIndice.search("#GEN") >= 0)
                GetObjControlador().navegarAPagina(GetObjConstantes()._GENERICO, opcionIndice); 
            
            CatalogoWebUI.setPrinterVisible(true);
        }
    }

    this.favoriteado = function (ele) {
        if (ele != undefined) {
            var id = ko.dataFor(ele).id;
            var tipoEmpresa = ko.dataFor(ele).tipo;
            var stand = ko.dataFor(ele).stand;
            if ($(ele).attr("src") == "img/fav_off.png") {
                $(ele).attr("src", "img/fav_on.png");
                $(ele).addClass("icon-star-fill");
                $(ele).removeClass("icon-star");
                if (tipoEmpresa === "C")
                    GetFavoritos().AddFavorito(id, GetObjConfiguracion().feria, stand);
                else
                    GetFavoritos().AddFavorito(id, GetObjConfiguracion().feria, 'X');
            } else {
                $(ele).attr("src", "img/fav_off.png");
                $(ele).addClass("icon-star");
                $(ele).removeClass("icon-star-fill");
                GetFavoritos().DeleteFavorito(id, GetObjConfiguracion().feria);
            }
        }
    }

    this.cargarFavorito = function (ele) {
        if (ele != undefined) {
            var id = ko.dataFor(ele).id;
            if (GetFavoritos().BuscarFavorito(id, GetObjConfiguracion().feria))
                $(ele).attr("src", "img/fav_on.png");
        }
    }

    this.cargaHTMLBusquedaPais = function (data) {
        $("#ListaEmpresasPaises").html(data);
    }
    
    this.mostrarListaEmpresas = function (tipoBusqueda, txtBusqueda) {
        GetObjConfiguracion().numPagina = 1;
        GetObjControlador().cargarListaEmpresas("", GetObjConfiguracion().numPagina, GetObjConfiguracion().numEmpresas, tipoBusqueda, txtBusqueda);
    }

    this.crearObjetoPaginacion = function (numeroTotalEmpresas, numPagina, numEmpresasPorPagina, tipoBusqueda, txtBusqueda) {       
        $('#pagination-empresas').remove();
        var modulo = numeroTotalEmpresas % numEmpresasPorPagina;
        var nPagina = numPagina, tBusqueda = tipoBusqueda, txBusqueda = txtBusqueda, nTotal;
        if (modulo > 0)
            nTotal = parseInt(numeroTotalEmpresas / numEmpresasPorPagina) + 1;
        else
            nTotal = parseInt(numeroTotalEmpresas / numEmpresasPorPagina);
        
        if (nTotal > 1) {
            $("#Paginacion").append("<ul id='pagination-empresas' class='pagination-sm'> </ul>");
            $('#pagination-empresas').twbsPagination({
                totalPages: nTotal,
                visiblePages: 5,
                startPage: nPagina,
                first: ' ',
                prev: ' ',
                next: ' ',
                last: ' ',
                onPageClick: function (event, page) {
                    if (GetObjConfiguracion().activarEventosPagina) {
                        var tipo, url;

                        // Caso generico.
                        var filtroBusqueda = jQuery.inArray(GetObjConfiguracion().busquedaActiva,
                            GetObjConfiguracion().arrayOpcionesBusqueda);

                        if (GetObjConfiguracion().busquedaActiva == "T") {
                            tipo = GetObjConstantes()._LISTA;
                            url = '#LEMPRESAS&p=' + page;
                        } else if (GetObjConfiguracion().busquedaActiva == "S") {
                            tipo = GetObjConstantes()._SECTOR;
                            url = '#LSECTOR&p=' + page + "&s=" + GetObjConfiguracion().filtroBusquedaActiva;
                        } else if (GetObjConfiguracion().busquedaActiva == "P") {
                            tipo = GetObjConstantes()._PAIS;
                            url = '#LPAISES&p=' + page + "&c=" + GetObjConfiguracion().filtroBusquedaActiva;
                        } else if (GetObjConfiguracion().busquedaActiva == "A") {
                            tipo = GetObjConstantes()._ACTIVIDAD;
                            url = '#LACTIVIDAD&p=' + page + "&a=" + GetObjConfiguracion().filtroBusquedaActiva;
                        } else if (GetObjConfiguracion().busquedaActiva == "O") {
                            tipo = GetObjConstantes()._PRODUCTO;
                            url = '#LPRODUCTOS&p=' + page + "&o=" + GetObjConfiguracion().filtroBusquedaActiva;
                        } else if (GetObjConfiguracion().busquedaActiva == "R") {
                            tipo = GetObjConstantes()._REPRESENTADA;
                            url = '#LREPRESENTADAS&p=' + page + "&r=" + GetObjConfiguracion().filtroBusquedaActiva;
                        } else if (GetObjConfiguracion().busquedaActiva == "M") {
                            tipo = GetObjConstantes()._MARCA;
                            url = '#LMARCAS&p=' + page + "&m=" + GetObjConfiguracion().filtroBusquedaActiva;
                        } else if (GetObjConfiguracion().busquedaActiva == "ST") {
                            tipo = GetObjConstantes()._STAND;
                            url = '#LSTANDS&p=' + page + "&st=" + GetObjConfiguracion().filtroBusquedaActiva;
                        } else if (filtroBusqueda == -1) {
                            tipo = GetObjConstantes()._GENERICO;
                            url = '#GEN&p=' + page + "&g=" + GetObjConfiguracion().busquedaActiva + "&s=" + 
                                GetObjConfiguracion().filtroBusquedaActiva;
                        }

                        // Busqueda normal.
                        if (tipoBusqueda != "") {
                            url += "&t=" + tipoBusqueda;
                            if (tipoBusqueda != "TODO") {
                                url += "&b=" + txtBusqueda;
                            }
                        }

                        GetObjControlador().navegarAPagina(tipo, url);
                    }
                }
            });
        }
    }
    
    this.activarPaginacion = function () {
        GetObjConfiguracion().activarEventosPagina = true;
        if ($("#pagination-empresas").length > 0) {
            $('#pagination-empresas').twbsShowPage(GetObjConfiguracion().numPagina);
            $("#pagination-empresas li:first-child a").addClass("paginacion_first");
            $("#pagination-empresas .prev a").addClass("paginacion_backward");
            $("#pagination-empresas .next a").addClass("paginacion_forward");
            $("#pagination-empresas li:last-child a").addClass("paginacion_last");
        }
    }

    this.crearObjetoPaginacionFavoritos = function (numeroTotalEmpresas, numPagina, numEmpresasPorPagina, tipoBusqueda, txtBusqueda) {
        $('#pagination-favoritos').remove();
        var modulo = numeroTotalEmpresas % numEmpresasPorPagina;
        var nPagina = numPagina, tBusqueda = tipoBusqueda, txBusqueda = txtBusqueda, nTotal;
        if (modulo > 0)
            nTotal = parseInt(numeroTotalEmpresas / numEmpresasPorPagina) + 1;
        else
            nTotal = parseInt(numeroTotalEmpresas / numEmpresasPorPagina);

        if (nTotal > 1) {
            $("#PaginacionFavoritos").append("<ul id='pagination-favoritos' class='pagination-sm'> </ul>");
            $('#pagination-favoritos').twbsPagination({
                totalPages: nTotal,
                visiblePages: 5,
                startPage: nPagina,
                first: ' ',
                prev: ' ',
                next: ' ',
                last: ' ',
                onPageClick: function (event, page) {
                    if (GetObjConfiguracion().activarEventosPagina) {
                        GetObjControlador().navegarAPagina(GetObjConstantes()._FAVORITOS, '#FAVORITOS&p=' + page);//window.location.hash = '#FAVORITOS&p=' + page;
                    }
                }
            });
        }
    }

    this.activarPaginacionFavoritos = function () {
        GetObjConfiguracion().activarEventosPagina = true;
        if ($("#pagination-favoritos").length > 0) {
            $('#pagination-favoritos').twbsShowPage(GetObjConfiguracion().numPagina);
            $("#pagination-favoritos li:first-child a").addClass("paginacion_first");
            $("#pagination-favoritos .prev a").addClass("paginacion_backward");
            $("#pagination-favoritos .next a").addClass("paginacion_forward");
            $("#pagination-favoritos li:last-child a").addClass("paginacion_last");
        }

        //if ($("#pagination-favoritos").length > 0) {
        //    $('#pagination-favoritos').twbsShowPage(GetObjConfiguracion().numPagina);
        //    $("#pagination-favoritos li:first-child a").addClass("glyphicon glyphicon-step-backward");
        //    $("#pagination-favoritos .prev a").addClass("glyphicon glyphicon-backward");
        //    $("#pagination-favoritos .next a").addClass("glyphicon glyphicon-forward");
        //    $("#pagination-favoritos li:last-child a").addClass("glyphicon glyphicon-step-forward");
        //}
    }

    //ajax_ListaEmpresa.html se aisla dentro de una etiqueta script asi que
    //hago esta ñapa para la traducción al no poder acceder de manera facil los
    //scripts de traduccion
    if (GetObjConfiguracion().idio == "es") {
        visitaWeb = "Visitar sitio web"
        verPlanoInter = "Ver plano interactivo"
        verMas = "Ver más"
    }
    else {
        visitaWeb = "Visit website"
        verPlanoInter = "Floor plan"
        verMas = "Read more"
    }

    this.cargarListaEmpresasFavoritas = function () {
        var listaFavoritos =  GetFavoritos().obtenerListaFavoritos();
        CatalogoWebUI.limpiarListaFavoritos();
        if (GetObjConfiguracion().idio == "es") {
            var url = "../wsListaExpositores.svc/GetEmpresasFavoritas?Feria=" + GetObjConfiguracion().feria + "&Ids=" + listaFavoritos + "&idioma=es&" +
                "numero=" + GetObjConfiguracion().numEmpresas + "&pagina=" + GetObjConfiguracion().numPagina;
            GetCargaArchivos().CargarFicheroJSON(GetObjListaEmpresas().pintarFavoritosUI_es, url);
        }
        else {
            var url = "../wsListaExpositores.svc/GetEmpresasFavoritas?Feria=" + GetObjConfiguracion().feria + "&Ids=" + listaFavoritos + "&idioma=en&" +
                "numero=" + GetObjConfiguracion().numEmpresas + "&pagina=" + GetObjConfiguracion().numPagina;
            GetCargaArchivos().CargarFicheroJSON(GetObjListaEmpresas().pintarFavoritosUI_en, url);
        }
    }

    //TODO: el ws debera exponer un metodo por tipo de fichero// tipo de indice
    this.cargarListaEmpresas = function () {
        var url = "../wsListaExpositores.svc/GetIndiceEmpresasPais?Feria=" + GetObjConfiguracion().feria +
            "&tipoBusqueda=" + GetObjConfiguracion().tipoBusqueda + "&numero=" + GetObjConfiguracion().numEmpresas +
            "&pagina=" + GetObjConfiguracion().numPagina + "&Tipoindice=" + GetObjConfiguracion().busquedaActiva;

        // Caso generico. 
        var filtroBusqueda = jQuery.inArray(GetObjConfiguracion().busquedaActiva,
            GetObjConfiguracion().arrayOpcionesBusqueda);

        if (GetObjConfiguracion().busquedaActiva == "S" || GetObjConfiguracion().busquedaActiva == "P" ||
            GetObjConfiguracion().busquedaActiva == "A" || GetObjConfiguracion().busquedaActiva == "O" ||
            GetObjConfiguracion().busquedaActiva == "M" || GetObjConfiguracion().busquedaActiva == "R" ||
            GetObjConfiguracion().busquedaActiva == "ST" || filtroBusqueda == -1) {
            url +=  "&idindice=" + GetObjConfiguracion().filtroBusquedaActiva;
        } 

        // Busqueda normal.
        if (GetObjConfiguracion().tipoBusqueda != "TODO") {
            url += "&texto=" + GetObjConfiguracion().textoBusqueda;
        }

        // Busqueda cruzada.
        var paisId = $.trim(GetObjConfiguracion().paisId);
        if (paisId != "") {
            url += "&PaisId=" + GetObjConfiguracion().paisId;
        }

        if (GetObjConfiguracion().idio == "es") {
            GetCargaArchivos().CargarFicheroJSON(that.pintarEmpresasUI_es, url);
        } else {
            GetCargaArchivos().CargarFicheroJSON(that.pintarEmpresasUI_en, url);
        }
    }

    this.cargarTxtOpcionElegida = function (feria,busquedaActiva,idioma,id) {
        var url = "../wsListaExpositores.svc/GetIndiceMaestroId?Feria=" + feria +
                   "&Tipoindice=" + busquedaActiva + "&idioma=" + idioma + "&Id=" + id;
        GetCargaArchivos().CargarObjetoJSON(that.actualizarTxt, url);
    }

    this.actualizarTxt = function (data) {
        if (data != null) {
            if (data.d != undefined && data.d != "" && data.d.length > 0) {
                if (GetObjConfiguracion().verImpresion)
                    CatalogoWebUI.opcionElegida(data.d);
                else
                    CatalogoWebUI.opcionElegida("- " + data.d);

                GetObjControlador().saveAnalyticsFiltros(data.d);
            }
        }
    }

    this.cargarIndiceMaestro = function (tipoMaestro) {
        var url = "";
        if (GetObjConfiguracion().tipoBusqueda == "TODO") {
            var filtroBusqueda = jQuery.inArray(GetObjConfiguracion().busquedaActiva, GetObjConfiguracion().arrayOpcionesBusqueda); 
            if (filtroBusqueda == -1) 
                url = "../wsListaExpositores.svc/GetIndiceMaestro?Feria=" + GetObjConfiguracion().feria + 
                   "&tipoBusqueda=TODO&numero=" + GetObjConfiguracion().numEmpresas + "&pagina=" + GetObjConfiguracion().numPagina +
                   "&Tipoindice=" + tipoMaestro + "&idioma=" + GetObjConfiguracion().idio;
            else
                url = "../wsListaExpositores.svc/GetIndiceMaestro?Feria=" + GetObjConfiguracion().feria + 
                    "&tipoBusqueda=TODO&numero=" + GetObjConfiguracion().numEmpresas + "&pagina=" + GetObjConfiguracion().numPagina +
                    "&Tipoindice=" + GetObjConfiguracion().busquedaActiva + "&idioma=" + GetObjConfiguracion().idio;
        }
        else {
            var filtroBusqueda = jQuery.inArray(GetObjConfiguracion().busquedaActiva, GetObjConfiguracion().arrayOpcionesBusqueda);  
            if (filtroBusqueda == -1)
                url = "../wsListaExpositores.svc/GetIndiceMaestro?Feria=" + GetObjConfiguracion().feria +
                    "&tipoBusqueda=" + GetObjConfiguracion().tipoBusqueda + "&numero=" + GetObjConfiguracion().numEmpresas +
                    "&pagina=" + GetObjConfiguracion().numPagina + "&Tipoindice=" + tipoMaestro + "&texto=" + GetObjConfiguracion().textoBusqueda +
                    "&idioma=" + GetObjConfiguracion().idio;
            else
                url = "../wsListaExpositores.svc/GetIndiceMaestro?Feria=" + GetObjConfiguracion().feria +
                    "&tipoBusqueda=" + GetObjConfiguracion().tipoBusqueda + "&numero=" + GetObjConfiguracion().numEmpresas +
                    "&pagina=" + GetObjConfiguracion().numPagina + "&Tipoindice=" + GetObjConfiguracion().busquedaActiva + "&texto=" + GetObjConfiguracion().textoBusqueda +
                    "&idioma=" + GetObjConfiguracion().idio;
        }

        CatalogoWebUI.limpiarListaBusquedaSimple();
        GetObjConfiguracion().arrayIndice = [];
        GetCargaArchivos().CargarFicheroJSON(that.pintarindiceUI, url);
    }

    //***** indice busquedas simples ***///////////
    this.CollapseTree = function () {
        $('.tree li.parent_li > span').each(function () {
            var children = $(this).parent('li.parent_li').find(' > ul > li');
            if (children.is(":visible")) {
                children.hide('fast');
                $(this).attr('title', 'Expand').find(' > i').addClass('glyphicon-plus').removeClass('glyphicon-minus');
            }
        });
    }

    this.ExpandTree = function () {
        $('.tree li.parent_li > span').each(function () {
            var children = $(this).parent('li.parent_li').find(' > ul > li');
            if (!children.is(":visible")) {
                children.show('fast');
                $(this).attr('title', 'Collapse').find(' > i').addClass('glyphicon-minus').removeClass('glyphicon-plus');
            }
        });
    }

    this.actualizarEstilosTree = function (showCollapseDownUp) {
        if (showCollapseDownUp) {
            $('.tree .collapseDown').show('fast');
            $('.tree .collapseDown').unbind().on('click', function (e) {
                that.ExpandTree();
                e.stopPropagation();
            });

            $('.tree .collapseUp').show('fast');
            $('.tree .collapseUp').unbind().on('click', function (e) {
                that.CollapseTree();
                e.stopPropagation();
            });
        } else {
            $('.tree .collapseDown').hide('fast');
            $('.tree .collapseUp').hide('fast');
        }

        $('.tree li:has(ul)').addClass('parent_li').find(' > span').attr('title', 'Collapse this branch');

        $('.tree li.parent_li > span').on('click', function (e) {
            var children = $(this).parent('li.parent_li').find(' > ul > li');
            if (children.is(":visible")) {
                children.hide('fast');
                $(this).attr('title', 'Expand').find(' > i').addClass('glyphicon-plus').removeClass('glyphicon-minus');
            } else {
                children.show('fast');
                $(this).attr('title', 'Collapse').find(' > i').addClass('glyphicon-minus').removeClass('glyphicon-plus');
            }
            e.stopPropagation();
        });
    }
    
    this.crearObjetoPaginacionIndice = function (numeroTotalEmpresas, numPagina, numEmpresasPorPagina, tipoBusqueda, txtBusqueda) {
        $('#pagination-indice').remove();
        var modulo = numeroTotalEmpresas % numEmpresasPorPagina;
        var nPagina = numPagina, tBusqueda = tipoBusqueda, txBusqueda = txtBusqueda, nTotal;
        if (modulo > 0)
            nTotal = parseInt(numeroTotalEmpresas / numEmpresasPorPagina) + 1;
        else
            nTotal = parseInt(numeroTotalEmpresas / numEmpresasPorPagina);

        if (nTotal > 1) {
            $("#PaginacionIndice").append("<ul id='pagination-indice' class='pagination-sm'> </ul>");
            $('#pagination-indice').twbsPagination({
                totalPages: nTotal,
                visiblePages: 5,
                startPage: nPagina,
                first: ' ',
                prev: ' ',
                next: ' ',
                last: ' ',
                onPageClick: function (event, page) {
                    if (GetObjConfiguracion().activarEventosPagina) {
                        var tipo, url;

                        // Caso generico.
                        var filtroBusqueda = jQuery.inArray(GetObjConfiguracion().busquedaActiva,
                            GetObjConfiguracion().arrayOpcionesBusqueda);

                        if (GetObjConfiguracion().busquedaActiva == "S") {
                            tipo = GetObjConstantes()._SECTOR;
                            url = '#LSECTOR&p=' + page + "&s=" + GetObjConfiguracion().filtroBusquedaActiva;
                        } else if (GetObjConfiguracion().busquedaActiva == "P") {
                            tipo = GetObjConstantes()._PAIS;
                            url = '#LPAISES&p=' + page + "&c=" + GetObjConfiguracion().filtroBusquedaActiva;
                        } else if (GetObjConfiguracion().busquedaActiva == "A") {
                            tipo = GetObjConstantes()._ACTIVIDAD;
                            url = '#LACTIVIDAD&p=' + page + "&a=" + GetObjConfiguracion().filtroBusquedaActiva;
                        } else if (GetObjConfiguracion().busquedaActiva == "O") {
                            tipo = GetObjConstantes()._PRODUCTO;
                            url = '#LPRODUCTOS&p=' + page + "&o=" + GetObjConfiguracion().filtroBusquedaActiva;
                        } else if (GetObjConfiguracion().busquedaActiva == "R") {
                            tipo = GetObjConstantes()._REPRESENTADA;
                            url = '#LREPRESENTADAS&p=' + page + "&r=" + GetObjConfiguracion().filtroBusquedaActiva;
                        } else if (GetObjConfiguracion().busquedaActiva == "M") {
                            tipo = GetObjConstantes()._MARCA;
                            url = '#LMARCAS&p=' + page + "&m=" + GetObjConfiguracion().filtroBusquedaActiva;
                        } else if (GetObjConfiguracion().busquedaActiva == "ST") {
                            tipo = GetObjConstantes()._STAND;
                            url = '#LSTANDS&p=' + page + "&st=" + GetObjConfiguracion().filtroBusquedaActiva;
                        } else if (filtroBusqueda == -1) {
                            tipo = GetObjConstantes()._GENERICO;
                            url = '#GEN&p=' + page + "&g=" + GetObjConfiguracion().busquedaActiva + "&s=" +
                                GetObjConfiguracion().filtroBusquedaActiva;
                        }

                        // Bsqueda normal.
                        if (tipoBusqueda != "") {
                            url += "&t=" + tipoBusqueda;
                            if (tipoBusqueda != "TODO") {
                                url += "&b=" + txtBusqueda;
                            }
                        }

                        GetObjControlador().navegarAPagina(tipo, url);
                    }
                }
            });
        }
    }

    this.activarPaginacionIndice = function () {
        GetObjConfiguracion().activarEventosPagina = true;
        if ($("#pagination-indice").length > 0) {
            $('#pagination-indice').twbsShowPage(GetObjConfiguracion().numPagina);
            $("#pagination-indice li:first-child a").addClass("paginacion_first");
            $("#pagination-indice .prev a").addClass("paginacion_backward");
            $("#pagination-indice .next a").addClass("paginacion_forward");
            $("#pagination-indice li:last-child a").addClass("paginacion_last");
        }

        //if ($("#pagination-indice").length > 0) {
        //    $('#pagination-indice').twbsShowPage(GetObjConfiguracion().numPagina);
        //    $("#pagination-indice li:first-child a").addClass("glyphicon glyphicon-step-backward");
        //    $("#pagination-indice .prev a").addClass("glyphicon glyphicon-backward");
        //    $("#pagination-indice .next a").addClass("glyphicon glyphicon-forward");
        //    $("#pagination-indice li:last-child a").addClass("glyphicon glyphicon-step-forward");
        //}
    }

    this.paginacionIndice = function () {
        GetObjConfiguracion().activarEventosPagina = false;
        that.crearObjetoPaginacionIndice(GetObjConfiguracion().numTotalEmpresas, GetObjConfiguracion().numPagina, GetObjConfiguracion().numEmpresas, GetObjConfiguracion().tipoBusqueda, GetObjConfiguracion().textoBusqueda);
        that.activarPaginacionIndice();
    }

    this.pintarindiceUI = function (datos) {
            var nodosHijos;
            var nodosConLink = [];
            var link;
            if (datos != null) {
                GetObjConfiguracion().numTotalEmpresas = datos.t;
                GetObjConfiguracion().actualizarTextoNumeroResultados();
                that.paginacionIndice();
                var data = datos.d;
                if (GetObjConfiguracion().busquedaActiva == "S")
                    link = GetObjConstantes().LINK_SECTOR + "&i=" + GetObjConfiguracion().idio + "&t=" + GetObjConfiguracion().tipoBusqueda + "&e=" + GetObjConfiguracion().numEmpresas + "&b=&s=";
                else if (GetObjConfiguracion().busquedaActiva == "P")
                    link = GetObjConstantes().LINK_PAIS + "&i=" + GetObjConfiguracion().idio + "&t=" + GetObjConfiguracion().tipoBusqueda + "&e=" + GetObjConfiguracion().numEmpresas + "&b=&c=";
                else if (GetObjConfiguracion().busquedaActiva == "A")
                    link = GetObjConstantes().LINK_ACTIVIDAD + "&i=" + GetObjConfiguracion().idio + "&t=" + GetObjConfiguracion().tipoBusqueda + "&e=" + GetObjConfiguracion().numEmpresas + "&b=&a=";
                else if (GetObjConfiguracion().busquedaActiva == "O")
                    link = GetObjConstantes().LINK_PRODUCTO + "&i=" + GetObjConfiguracion().idio + "&t=" + GetObjConfiguracion().tipoBusqueda + "&e=" + GetObjConfiguracion().numEmpresas + "&b=&o=";
                else if (GetObjConfiguracion().busquedaActiva == "R")
                    link = GetObjConstantes().LINK_REPRESENTADA + "&i=" + GetObjConfiguracion().idio + "&t=" + GetObjConfiguracion().tipoBusqueda + "&e=" + GetObjConfiguracion().numEmpresas + "&b=&r=";
                else if (GetObjConfiguracion().busquedaActiva == "M")
                    link = GetObjConstantes().LINK_MARCA + "&i=" + GetObjConfiguracion().idio + "&t=" + GetObjConfiguracion().tipoBusqueda + "&e=" + GetObjConfiguracion().numEmpresas + "&b=&m=";
                else if (GetObjConfiguracion().busquedaActiva == "ST")
                    link = GetObjConstantes().LINK_STAND + "&i=" + GetObjConfiguracion().idio + "&t=" + GetObjConfiguracion().tipoBusqueda + "&e=" + GetObjConfiguracion().numEmpresas + "&b=&st=";
                else
                    link = '#GEN&p=1&g=' + GetObjConfiguracion().busquedaActiva + '&s=';

                var totalElementosVisibles = data.length;
                for (i = 0; i < data.length; i++) {
                    nodosConLink = [];
                    nodosHijos = data[i].hijos;
                    if (nodosHijos != undefined) {
                        totalElementosVisibles += nodosHijos.length;
                        for (j = 0; j < nodosHijos.length; j++) {
                            nodosConLink.push({ nombre: nodosHijos[j].no, nombrei: nodosHijos[j].noi, id: nodosHijos[j].id, link: link + nodosHijos[j].id });
                        }
                    }
                    CatalogoWebUI.listaBusquedaSimple.push({ nombre: data[i].no, nombrei: data[i].noi, id: data[i].id, hijos: nodosConLink, link: link + data[i].id });
                    GetObjConfiguracion().arrayIndice.push({ nombre: data[i].no, nombrei: data[i].noi, id: data[i].id, hijos: nodosConLink, link: link + data[i].id });
                }
                CatalogoWebUI.setOpcionElegida();

                that.actualizarEstilosTree(totalElementosVisibles > data.length);

                var limiteElementosHijosVisibles = GetObjConfiguracion().numEmpresas * 2;
                if (totalElementosVisibles > limiteElementosHijosVisibles) {
                    that.CollapseTree();
                }
            }
            $('#loading-indicator').hide();
    }

    //***** fin indice busquedas simples ***///////////   
    //tipo 1 - empieza por // 2 - textl // 3 - todos
    this.filtroIndice = function (filtro, tipo) {
        CatalogoWebUI.limpiarListaBusquedaSimple();
        var nodosHijos;
        var auxNodosHijos = [];
        var mFiltro = filtro.toUpperCase();
        var tieneHijos = false, tienePadre = false;

        var totalElementosVisibles = data.length;

        for (i = 0; i < GetObjConfiguracion().arrayIndice.length; i++) {
            tienePadre = false; auxNodosHijos = [];
            nodosHijos = GetObjConfiguracion().arrayIndice[i].hijos;
            if (nodosHijos != undefined)
            {
                totalElementosVisibles += nodosHijos.length;
                for (j = 0; j < nodosHijos.length; j++)
                {
                    tieneHijos = false;
                    if ((GetObjConfiguracion().idio == "es") && (tipo == 1))
                        tieneHijos = nodosHijos[j].nombre.toUpperCase().indexOf(mFiltro) == 0;
                    if ((GetObjConfiguracion().idio == "en") && (tipo == 1))
                        tieneHijos = nodosHijos[j].nombrei.toUpperCase().indexOf(mFiltro) == 0;
                    if ((GetObjConfiguracion().idio == "es") && (tipo == 2))
                        tieneHijos = nodosHijos[j].nombre.toUpperCase().indexOf(mFiltro) !== -1;
                    if ((GetObjConfiguracion().idio == "en") && (tipo == 2))
                        tieneHijos = nodosHijos[j].nombrei.toUpperCase().indexOf(mFiltro) !== -1;

                    if (tieneHijos || tipo == 3) {
                        tienePadre = true;
                        auxNodosHijos.push({ nombre: nodosHijos[j].nombre, nombrei: nodosHijos[j].nombrei, id: nodosHijos[j].id, link: nodosHijos[j].link });
                    }
                }
            }

            if (tienePadre || tipo == 3)
                CatalogoWebUI.listaBusquedaSimple.push({ nombre: GetObjConfiguracion().arrayIndice[i].nombre, nombrei: GetObjConfiguracion().arrayIndice[i].nombrei, id: GetObjConfiguracion().arrayIndice[i].id, hijos: auxNodosHijos, link: GetObjConfiguracion().arrayIndice[i].link });
            else {
                tienePadre = false;
                if ((GetObjConfiguracion().idio == "es") && (tipo == 1))
                    tienePadre = GetObjConfiguracion().arrayIndice[i].nombre.toUpperCase().indexOf(mFiltro) == 0;
                if ((GetObjConfiguracion().idio == "en") && (tipo == 1))
                    tienePadre = GetObjConfiguracion().arrayIndice[i].nombrei.toUpperCase().indexOf(mFiltro) == 0;
                if ((GetObjConfiguracion().idio == "es") && (tipo == 2))
                    tienePadre = GetObjConfiguracion().arrayIndice[i].nombre.toUpperCase().indexOf(mFiltro) !== -1;
                if ((GetObjConfiguracion().idio == "en") && (tipo == 2))
                    tienePadre = GetObjConfiguracion().arrayIndice[i].nombrei.toUpperCase().indexOf(mFiltro) !== -1;

                if (tienePadre || tipo == 3)
                    CatalogoWebUI.listaBusquedaSimple.push({ nombre: GetObjConfiguracion().arrayIndice[i].nombre, nombrei: GetObjConfiguracion().arrayIndice[i].nombrei, id: GetObjConfiguracion().arrayIndice[i].id, hijos: auxNodosHijos, link: GetObjConfiguracion().arrayIndice[i].link });
            }
        }

        that.actualizarEstilosTree(totalElementosVisibles > data.length);

        var limiteElementosHijosVisibles = GetObjConfiguracion().numEmpresas * 2;
        if (totalElementosVisibles > limiteElementosHijosVisibles) {
            that.CollapseTree();
        }
    }

    //********** lista empresas
    this.paginacionListaEmpresas = function () {
        GetObjConfiguracion().activarEventosPagina = false;
        that.crearObjetoPaginacion(GetObjConfiguracion().numTotalEmpresas, GetObjConfiguracion().numPagina, GetObjConfiguracion().numEmpresas, GetObjConfiguracion().tipoBusqueda, GetObjConfiguracion().textoBusqueda);
        that.activarPaginacion();
    }

    this.pintarEmpresasUI_es = function(datos) {
        var no, stand, id, tipo, logo, rutaImagen, www, verWww, descActi, web, actividad, favorito;
        var feria, fichaEmpresa, PlanoFeria, linkSVR;

        if (datos != null) {
            if (!GetObjConfiguracion().verImpresion) {
                GetObjConfiguracion().numTotalEmpresas = datos.t;
                GetObjConfiguracion().actualizarTextoNumeroResultados();
                that.paginacionListaEmpresas();
            }
            var data = datos.d;

            if (data != null) {
                var nuevoarrayEmpresas = [];
                for (i = 0; i < data.length; i++) {
                    no = data[i].no;
                    stand = data[i].st;
                    id = data[i].id;
                    tipo = data[i].te;
                    logo = data[i].url;
                    www = data[i].we;
                    actividad = data[i].dc;
                    if (actividad.length == 0) {
                        if (tipo == "E" || tipo == "C")
                            actividad = "Empresa participante en la feria.";
                        if (tipo == "M" || tipo == "R")
                            actividad = "Presente en la feria en el stand de ...";
                    }
                    if (www != null && www != "") {
                        if (www.indexOf("http") == -1)
                            web = "http://" + www;
                        else
                            web = www;
                    }
                    else
                        web = "";

                    if ((web.length > 0) && (GetObjConfiguracion().verPIM === 'N'))
                        verWww = true;
                    else
                        verWww = false;

                    if (logo != null && logo != "") {
                        if (!GetObjConfiguracion().verImpresion)
                            rutaImagen = GetObjConfiguracion().GetRutaFichero("I", logo);
                        else {
                            if (logo === "f_no_LOGO.jpg")
                                rutaImagen = "";
                            else
                                rutaImagen = GetObjConfiguracion().GetRutaFichero("I", logo);
                        }
                    } else {
                        if (!GetObjConfiguracion().verImpresion)
                            rutaImagen = GetObjConfiguracion().getRutaImagenPorDefecto(); //CatalogoWebUI.logoEsp;// "img/sinlogo150.jpg";
                        else
                            rutaImagen = "";
                    }

                    if (!GetObjConfiguracion().verImpresion) {
                        if (GetFavoritos().BuscarFavorito(id, GetObjConfiguracion().feria))
                            favorito = "img/fav_on.png";
                        else
                            favorito = "img/fav_off.png";
                        PlanoFeria = "#MAPA_FERIA?s=" + stand;
                        fichaEmpresa = "#FICHA_EMPRESA?emp=" + id;
                        feria = GetObjConfiguracion().feria;
                        linkSVR = that.componerLinkSVR(feria, id, "es");
                    }
                    else {
                        favorito = "";
                        fichaEmpresa = "";
                        PlanoFeria = "";
                        linkSVR = "";
                    }

                    nuevoarrayEmpresas.push({
                        feria: feria, nombre: no, stand: cortarPalabras(stand, 23), id: id, tipo: tipo, logo: rutaImagen,
                        actividad: actividad, linkSVR: linkSVR,
                        favorito: "Favorito", cita: ko.observable(""), verIconoCita: ko.observable(false),
                        verPlano: GetObjConfiguracion().opMapa, verWeb: verWww, www: web, plano: PlanoFeria,
                        fichaEmpresa: fichaEmpresa, fav: favorito
                    });
                }

                CatalogoWebUI.listaempresas(nuevoarrayEmpresas);
            }
        }
        if (!GetObjConfiguracion().verImpresion) {
            $('#loading-indicator').hide();
            idflag++;
            that.pintarServicioReuniones(CatalogoWebUI.listaempresas, idflag);
        }
        else {
            if (GetImpresionLocalStorage().imprimirTodos) {
                window.print();
                window.close();
            }
        }
    }


    this.componerLinkSVR = function (feria, idEmpresa, idioma) {
            var idEmpresaSeparado = idEmpresa.split("_");
            var codCatalogo = ((idEmpresaSeparado[2] < 10) ? "0" : "") + idEmpresaSeparado[2];
            var codInsercion = idEmpresaSeparado[0] + codCatalogo;
            var codempsec = idEmpresaSeparado[1];
            var link = GetObjControlador().urlSVR + "&codFeriaGC=" + feria + "&idioma=" + idioma + "&codInsercion=" + codInsercion + "&codempsec=" + codempsec;
            return link;
    }

    this.pintarServicioReuniones = function (listObjEmpr,idf) {
        if ((GetObjConfiguracion().opCita) && (listObjEmpr().length > 0))
        {
            var listEmpr = new Array();
            for (i = 0; i < listObjEmpr().length; i++) {
                listEmpr.push({id:listObjEmpr()[i].id,activo:'N'});
            }
            url = "../wsListaExpositores.svc/GetEmpresasConAgenda";
            var data = {
                Feria: GetObjConfiguracion().feria,
                ListaEmpresasAComprobar: listEmpr
            }
            GetCargaArchivos().CargarFicheroJSONPost(that.pintarServicioReunionesUI, url, data, listObjEmpr,idf);
        }
    }

    this.pintarServicioReunionesUI = function(datos, listaObjEmpr,idf)
    {
        if (idf == idflag) //Si son distintos es que antes de cargar ya han cambiado a otra busqueda u otra pagina
        {
            for (i = 0; i < datos.length; i++)
            {
                if ((datos[i].activo == 'S') && (datos[i].id == listaObjEmpr()[i].id)) //por si acaso algo se me escapa compruebo que sea la misma empresa
                {
                    listaObjEmpr()[i].verIconoCita(true);
                    if (GetObjConfiguracion().idio == "es")
                        listaObjEmpr()[i].cita("Solicitar Cita");
                    else
                        listaObjEmpr()[i].cita("Request an appointment");
                }
                /*  else  No se si podria darse algun caso de que primero este activado y luego no
                al no ponerlo a false podriamos estar dando un resultado falso. Creo que esta situacion
                es muy dificil que se de con lo cual voy a dar prioridad a pintar mas rapido
                {
                    listaObjEmpr()[i].verIconoCita(false);
                    listaObjEmpr()[x].cita("");
                }*/
            }
        }

    }

    this.pintarEmpresasUI_en = function(datos) {
        var no, stand, id, tipo, logo, rutaImagen, www, verWww, web, actividad, favorito;
        var feria, fichaEmpresa, PlanoFeria, linkSVR;


        if (datos != null) {
            if (!GetObjConfiguracion().verImpresion) {
                GetObjConfiguracion().numTotalEmpresas = datos.t;
                GetObjConfiguracion().actualizarTextoNumeroResultados();
                that.paginacionListaEmpresas();
            }
            var data = datos.d;

            if (data != null) {
                var nuevoarrayEmpresas = [];
                for (i = 0; i < data.length; i++) {
                    no = data[i].no;
                    stand = data[i].st;
                    id = data[i].id;
                    tipo = data[i].te;
                    logo = data[i].url;
                    actividad = data[i].dci;

                    if (actividad.length == 0) {
                        if (tipo == "E" || tipo == "C")
                            actividad = "Company taking part in the fair.";
                        if (tipo == "M" || tipo == "R")
                            actividad = "Exhibition stand ...";
                    }

                    www = data[i].we;
                    if (www != null && www != "") {
                        if (www.indexOf("http") == -1)
                            web = "http://" + www;
                        else
                            web = www;
                    }
                    else
                        web = "";

                    if ((web.length > 0) && (GetObjConfiguracion().verPIM === 'N'))
                        verWww = true;
                    else
                        verWww = false;

                    if (logo != null && logo != "") {
                        if (!GetObjConfiguracion().verImpresion)
                            rutaImagen = GetObjConfiguracion().GetRutaFichero("I", logo);
                        else {
                            if (logo === "f_no_LOGO.jpg")
                                rutaImagen = "";
                            else
                                rutaImagen = GetObjConfiguracion().GetRutaFichero("I", logo);
                        }
                    } else {
                        if (!GetObjConfiguracion().verImpresion)
                            rutaImagen = GetObjConfiguracion().getRutaImagenPorDefecto();// "img/sinlogo150.jpg";
                        else
                            rutaImagen = "";
                    }

                    if (!GetObjConfiguracion().verImpresion) {
                        if (GetFavoritos().BuscarFavorito(id, GetObjConfiguracion().feria))
                            favorito = "img/fav_on.png";
                        else
                            favorito = "img/fav_off.png";
                        PlanoFeria = "#MAPA_FERIA?s=" + stand;
                        fichaEmpresa = "#FICHA_EMPRESA?emp=" + id;
                        feria = GetObjConfiguracion().feria;
                        linkSVR = that.componerLinkSVR(feria, id, "en");
                    }
                    else {
                        favorito = "";
                        fichaEmpresa = "";
                        PlanoFeria = "";
                        linkSVR = "";
                    }

                    nuevoarrayEmpresas.push({
                        nombre: no, stand: cortarPalabras(stand, 23), id: id, tipo: tipo, logo: rutaImagen,
                        actividad: actividad, linkSVR: linkSVR,
                        favorito: "Favourite", cita: ko.observable(""), verIconoCita: ko.observable(false),
                        verPlano: GetObjConfiguracion().opMapa, verWeb: verWww, www: web, plano: PlanoFeria,
                        fichaEmpresa: fichaEmpresa, fav: favorito
                    });
                }
                CatalogoWebUI.listaempresas(nuevoarrayEmpresas);
            }
        }
        if (!GetObjConfiguracion().verImpresion) {
            $('#loading-indicator').hide();
            idflag++;
            that.pintarServicioReuniones(CatalogoWebUI.listaempresas, idflag);
        }
        else {
            if (GetImpresionLocalStorage().imprimirTodos) {
                window.print();
                window.close();
            }
        }
    }
    //*********** fin lista de empresas

    //************ favoritos
    this.paginacionListaFavoritos = function () {
        GetObjConfiguracion().activarEventosPagina = false;
        GetObjListaEmpresas().crearObjetoPaginacionFavoritos(GetObjConfiguracion().numTotalEmpresas, GetObjConfiguracion().numPagina, GetObjConfiguracion().numEmpresas, "", "");
        GetObjListaEmpresas().activarPaginacionFavoritos();
    }

    this.pintarFavoritosUI_es = function (datos) {
        var no, stand, id, tipo, logo, rutaImagen, www, verWww, web, actividad, favorito, fichaEmpresa, PlanoFeria, linkSVR, feria;
        //var numeroTotalEmpresas = 10;
        if (datos != null) {
            if (!GetObjConfiguracion().verImpresion) {
                GetObjConfiguracion().numTotalEmpresas = datos.t;//numeroTotalEmpresas;
                GetObjConfiguracion().actualizarTextoNumeroResultados();
                that.paginacionListaFavoritos();
            }
            var data = datos.d;
            for (i = 0; i < data.length; i++) {
                no = data[i].no;
                stand = data[i].st;
                id = data[i].id;
                tipo = data[i].te;
                logo = data[i].url;
                www = data[i].we;
                
                actividad = data[i].dc;
                if (actividad.length == 0) {
                    if (tipo == "E" || tipo == "C")
                        actividad = "Empresa participante en la feria.";
                    if (tipo == "M" || tipo == "R")
                        actividad = "Exhibition stand ...";
                }

                if (www != null && www != "") {
                    if (www.indexOf("http") == -1)
                        web = "http://" + www;
                    else
                        web = www;
                }
                else
                    web = "";

                if ((web.length > 0) && (GetObjConfiguracion().verPIM === 'N'))
                    verWww = true;
                else
                    verWww = false;

                if (logo != null && logo != "") {
                    if (!GetObjConfiguracion().verImpresion)
                        rutaImagen = GetObjConfiguracion().GetRutaFichero("I", logo);
                    else {
                        if (logo === "f_no_LOGO.jpg")
                            rutaImagen = "";
                        else
                            rutaImagen = GetObjConfiguracion().GetRutaFichero("I", logo);
                    }
                } else {
                    if (!GetObjConfiguracion().verImpresion)
                        rutaImagen = GetObjConfiguracion().getRutaImagenPorDefecto(); //"img/sinlogo150.jpg";
                    else
                        rutaImagen = "";
                }

                if (!GetObjConfiguracion().verImpresion) {
                    if (GetFavoritos().BuscarFavorito(id, GetObjConfiguracion().feria))
                        favorito = "img/fav_on.png";
                    else
                        favorito = "img/fav_off.png";
                    PlanoFeria = "#MAPA_FERIA?s=" + stand;
                    fichaEmpresa = "index.html?feria=" + GetObjConfiguracion().feria + "#FICHA_EMPRESA?emp=" + id;
                    feria = GetObjConfiguracion().feria;
                    linkSVR = that.componerLinkSVR(feria, id, "es");
                }
                else {
                    favorito = "";
                    fichaEmpresa = "";
                    PlanoFeria = "";
                    linkSVR = "";
                }

                CatalogoWebUI.listaFavoritos.push({
                    feria: GetObjConfiguracion().feria, nombre: no, stand: cortarPalabras(stand, 23), id: id, tipo: tipo, logo: rutaImagen,
                    actividad: actividad, linkSVR: linkSVR,
                    favorito: "Favorito", cita: ko.observable(""), verIconoCita: ko.observable(false),
                    verPlano: GetObjConfiguracion().opMapa, verWeb: verWww, www: web, plano: PlanoFeria,
                    fichaEmpresa: fichaEmpresa, fav: favorito
                });
            }
        }
        if (!GetObjConfiguracion().verImpresion) {
            idflag++;
            that.pintarServicioReuniones(CatalogoWebUI.listaFavoritos, idflag);
        }
    }

    this.pintarFavoritosUI_en = function (datos) {
        var no, stand, id, tipo, logo, rutaImagen, www, verWww, web, actividad, favorito, fichaEmpresa, PlanoFeria, linkSVR, feria;

        if (datos != null) {
            if (!GetObjConfiguracion().verImpresion) {
                GetObjConfiguracion().numTotalEmpresas = datos.t;
                GetObjConfiguracion().actualizarTextoNumeroResultados();
                that.paginacionListaFavoritos();
            }

            var data = datos.d;
            for (i = 0; i < data.length; i++) {
                no = data[i].no;
                stand = data[i].st;
                id = data[i].id;
                tipo = data[i].te;
                logo = data[i].url;
                www = data[i].we;
                actividad = data[i].dci;
                
                if (actividad.length == 0) {
                    if (tipo == "E" || tipo == "C")
                        actividad = "Company taking part in the fair.";
                    if (tipo == "M" || tipo == "R")
                        actividad = "Exhibition stand ...";
                }
                
                if (www != null && www != "") {
                    if (www.indexOf("http") == -1)
                        web = "http://" + www;
                    else
                        web = www;
                }
                else
                    web = "";

                if ((web.length > 0) && (GetObjConfiguracion().verPIM === 'N'))
                    verWww = true;
                else
                    verWww = false;

                if (logo != null && logo != "") {
                    if (!GetObjConfiguracion().verImpresion)
                        rutaImagen = GetObjConfiguracion().GetRutaFichero("I", logo);
                    else {
                        if (logo === "f_no_LOGO.jpg")
                            rutaImagen = "";
                        else
                            rutaImagen = GetObjConfiguracion().GetRutaFichero("I", logo);
                    }
                } else {
                    if (!GetObjConfiguracion().verImpresion)
                        rutaImagen = GetObjConfiguracion().getRutaImagenPorDefecto(); //"img/sinlogo150.jpg";
                    else
                        rutaImagen = "";
                }
                
                if (!GetObjConfiguracion().verImpresion) {
                    if (GetFavoritos().BuscarFavorito(id, GetObjConfiguracion().feria))
                        favorito = "img/fav_on.png";
                    else
                        favorito = "img/fav_off.png";
                    fichaEmpresa = "index.html?feria=" + GetObjConfiguracion().feria + "#FICHA_EMPRESA?emp=" + id;
                    PlanoFeria = "#MAPA_FERIA?s=" + stand;
                    feria = GetObjConfiguracion().feria;
                    linkSVR = that.componerLinkSVR(feria, id, "en");
                }
                else {
                    favorito = "";
                    fichaEmpresa = "";
                    PlanoFeria = "";
                    linkSVR = "";
                }

                CatalogoWebUI.listaFavoritos.push({
                    nombre: no, stand: cortarPalabras(stand, 23), id: id, tipo: tipo, logo: rutaImagen,
                    actividad: actividad, linkSVR: linkSVR,
                    favorito: "Favourite", cita: ko.observable(""), verIconoCita: ko.observable(false),
                    verPlano: GetObjConfiguracion().opMapa, verWeb: verWww, www: web, plano: PlanoFeria,
                    fichaEmpresa: fichaEmpresa, fav: favorito
                });
            }
        }
        if (!GetObjConfiguracion().verImpresion) {
            idflag++;
            that.pintarServicioReuniones(CatalogoWebUI.listaFavoritos, idflag);
        }
    }

    //************ busqueda cruzada.
    this.actualizarImagenFiltro = function (inputFilter, targetImg) {
        var src = "";
        if (inputFilter.val() == "") {
            src = targetImg.attr("src").replace("cancel", "filter");
        } else {
            src = targetImg.attr("src").replace("filter", "cancel");
        }
        targetImg.attr("src", src);
    }
    this.limpiarFiltroPais = function () {
        $("#busquedaCruzada").val("");
        GetObjConfiguracion().paisId = "";
        GetObjListaEmpresas().actualizarImagenFiltro($("#busquedaCruzada"), $('#imgFiltrar'));
    }
    this.actualizarImagenFiltroMovil = function (inputFilter, targetButton) {
        targetButton.find('span').remove();

        var icon = document.createElement("span");
        if (inputFilter.val() == "") {
            icon.className = "glyphicon glyphicon-filter";
        } else {
            icon.className = "glyphicon glyphicon-remove";
        }
        targetButton.append(icon);
    }
    this.limpiarFiltroPaisMovil = function () {
        $("#busquedaCruzadaMovil").val("");
        GetObjConfiguracion().paisId = "";
        GetObjListaEmpresas().actualizarImagenFiltroMovil($("#busquedaCruzadaMovil"), $('#btnFiltrarMovil'));
    }
    this.obtenerNombrePais = function () {
        for (var i = 0, len = GetObjConfiguracion().arrayPaises.length; i < len; i++) {
            if (GetObjConfiguracion().paisId == GetObjConfiguracion().arrayPaises[i].value) {
                return GetObjConfiguracion().arrayPaises[i].label;
            }
        }
    }
    
};

ObjListaEmpresas.prototype = {
  
}